import DashboardStore from "./shared/DashboardStore";
import SalesTargetsStore from "./SalesTargets/SalesTargetsStore";

/**
 * One store for both dashboards: they read overlapping aggregates, and a user
 * moving between them should not re-fetch.
 */
const dashboardsStoreList = [
  { name: "dashboardStore", store: DashboardStore },
  // Named ...ViewStore to avoid colliding with the `salesTargetsStore` SERVICE
  // store that ServiceStore registration creates from the "sales-targets" path.
  { name: "salesTargetsViewStore", store: SalesTargetsStore },
];

export default dashboardsStoreList;
